export default "__VITE_ASSET__C_awsUr7__"